import MerchantIntegrationPreview from "./preview";
import MerchantIntegrationGeneric from "./generic";

import { Integration } from "./Integration";

export function integrationFor(platform: string): Promise<Integration> {
    return new Promise((resolve, reject) => {
        switch (platform) {
            case "preview":
                resolve(new MerchantIntegrationPreview());
                break;
            default:
                resolve(new MerchantIntegrationGeneric());
        }
    });
}
